var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"secondary",attrs:{"app":"","dark":"","dense":""},scopedSlots:_vm._u([(_vm.$route.name === 'agenda')?{key:"extension",fn:function(){return [_c('router-view',{attrs:{"name":"navigation-expanded"}})]},proxy:true}:null],null,true)},[_c('router-view',{attrs:{"name":"navigation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }